"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCUUtils = exports.LongSCU = exports.FullAgencySCU = exports.SearchSCU = exports.SCUModelEnum = exports.SCUStatusEnum = exports.SCU = void 0;
var cerealParse_1 = require("../cerealParse");
var functions_1 = require("../utils/functions");
var agency_1 = require("./agency");
/**
 * Class representing a SCU and providing a static parse method.
 */
var SCU = /** @class */ (function () {
    function SCU(id, name, serial, version) {
        this.id = id;
        this.name = name;
        this.serial = serial;
        this.version = version;
    }
    /**
     * Parse object potentially representing a SCU.
     * @param o
     * @return Parse result
     */
    SCU.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCU(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'serial'), cerealParse_1.ParseUtils.getStringOrNull(o, 'version')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCU Model: ".concat(e.message));
        }
    };
    return SCU;
}());
exports.SCU = SCU;
var SCUStatusEnum;
(function (SCUStatusEnum) {
    SCUStatusEnum[SCUStatusEnum["idle"] = 0] = "idle";
    SCUStatusEnum[SCUStatusEnum["audio"] = 1] = "audio";
    SCUStatusEnum[SCUStatusEnum["turnout"] = 2] = "turnout";
    SCUStatusEnum[SCUStatusEnum["offline"] = 3] = "offline";
})(SCUStatusEnum || (exports.SCUStatusEnum = SCUStatusEnum = {}));
var SCUModelEnum;
(function (SCUModelEnum) {
    SCUModelEnum[SCUModelEnum["p1"] = 0] = "p1";
    SCUModelEnum[SCUModelEnum["s1"] = 1] = "s1";
    SCUModelEnum[SCUModelEnum["s2"] = 2] = "s2";
    SCUModelEnum[SCUModelEnum["p2"] = 3] = "p2";
    SCUModelEnum[SCUModelEnum["p3"] = 4] = "p3";
    SCUModelEnum[SCUModelEnum["p3g"] = 5] = "p3g";
    SCUModelEnum[SCUModelEnum["other"] = 6] = "other";
})(SCUModelEnum || (exports.SCUModelEnum = SCUModelEnum = {}));
var SearchSCU = /** @class */ (function () {
    function SearchSCU(id, name, serial, email, swVersion, status, units) {
        this.id = id;
        this.name = name;
        this.serial = serial;
        this.email = email;
        this.swVersion = swVersion;
        this.status = status;
        this.units = units;
    }
    SearchSCU.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SearchSCU(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'serial'), cerealParse_1.ParseUtils.getStringOrNull(o, 'email'), cerealParse_1.ParseUtils.getStringOrNull(o, 'swVersion'), cerealParse_1.ParseUtils.getEnum(o, 'status', SCUStatusEnum), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', agency_1.AgencySCUUnit.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SearchSCU Model: ".concat(e.message));
        }
    };
    return SearchSCU;
}());
exports.SearchSCU = SearchSCU;
/**
 * Class representing a Full Agency SCU and providing a static parse method.
 */
var FullAgencySCU = /** @class */ (function () {
    function FullAgencySCU(id, units, connected, name, serial, station, ipAddress, macAddress, status, swVersion) {
        this.id = id;
        this.units = units;
        this.connected = connected;
        this.name = name;
        this.serial = serial;
        this.station = station;
        this.ipAddress = ipAddress;
        this.macAddress = macAddress;
        this.status = status;
        this.swVersion = swVersion;
    }
    FullAgencySCU.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullAgencySCU(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', agency_1.AgencySCUUnit.parse, 'warn'), cerealParse_1.ParseUtils.getBoolean(o, 'connected'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'serial'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'station', agency_1.Station.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'ipAddress'), cerealParse_1.ParseUtils.getStringOrNull(o, 'macAddress'), cerealParse_1.ParseUtils.getEnum(o, 'status', SCUStatusEnum), cerealParse_1.ParseUtils.getStringOrNull(o, 'swVersion')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullAgencySCU Model: ".concat(e.message));
        }
    };
    return FullAgencySCU;
}());
exports.FullAgencySCU = FullAgencySCU;
var LongSCU = /** @class */ (function () {
    function LongSCU(id, name, serial, ipAddress, macAddress, model, email, swVersion, status, agencies, location, 
    // Dates
    creationTs, shippedTs, deliveredTs, installedTs) {
        this.id = id;
        this.name = name;
        this.serial = serial;
        this.ipAddress = ipAddress;
        this.macAddress = macAddress;
        this.model = model;
        this.email = email;
        this.swVersion = swVersion;
        this.status = status;
        this.agencies = agencies;
        this.location = location;
        this.creationTs = creationTs;
        this.shippedTs = shippedTs;
        this.deliveredTs = deliveredTs;
        this.installedTs = installedTs;
    }
    LongSCU.parse = function (o) {
        try {
            var location_1 = cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'location', SCUUtils.parseSCULocation);
            return cerealParse_1.ParseUtils.parseSuccess(new LongSCU(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getString(o, 'serial'), cerealParse_1.ParseUtils.getStringOrNull(o, 'ipAddress'), cerealParse_1.ParseUtils.getStringOrNull(o, 'macAddress'), cerealParse_1.ParseUtils.getEnum(o, 'model', SCUModelEnum), cerealParse_1.ParseUtils.getStringOrNull(o, 'email'), cerealParse_1.ParseUtils.getStringOrNull(o, 'swVersion'), cerealParse_1.ParseUtils.getEnum(o, 'status', SCUStatusEnum), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'agencies', agency_1.LongSCUAgency.parse, 'warn'), location_1 != null ? location_1 : { type: 'none' }, cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'creationTs'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'shippedTs'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'deliveredTs'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'installedTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongSCU Model: ".concat(e.message));
        }
    };
    LongSCU.prototype.isAgencyMember = function (agencyId) {
        return this.agencies.filter(function (a) { return a.id == agencyId; }).length > 0;
    };
    return LongSCU;
}());
exports.LongSCU = LongSCU;
var SCUUtils = /** @class */ (function () {
    function SCUUtils() {
    }
    SCUUtils.getStatusLabelContent = function (status) {
        switch (status) {
            case SCUStatusEnum.idle:
                return 'Idle';
            case SCUStatusEnum.audio:
                return 'Audio';
            case SCUStatusEnum.turnout:
                return 'Turning Out';
            case SCUStatusEnum.offline:
                return 'Offline';
        }
    };
    SCUUtils.parseSCULocation = function (o) {
        try {
            var locationType = cerealParse_1.ParseUtils.getString(o, 'type');
            switch (locationType) {
                case 'none':
                    return cerealParse_1.ParseUtils.parseSuccess({ type: 'none' });
                case 'point':
                    return cerealParse_1.ParseUtils.parseSuccess({
                        type: 'point',
                        coordinates: o.location.coordinates.slice(0, 2).reverse(),
                    });
                case 'station':
                    return cerealParse_1.ParseUtils.parseSuccess({
                        type: 'station',
                        id: cerealParse_1.ParseUtils.getString(o, 'id'),
                        name: cerealParse_1.ParseUtils.getString(o, 'name'),
                        address: cerealParse_1.ParseUtils.getString(o, 'addr'),
                        agencyId: cerealParse_1.ParseUtils.getString(o, 'agencyId'),
                        coordinates: o.location.coordinates.slice(0, 2).reverse(),
                    });
                default:
                    return cerealParse_1.ParseUtils.parseFailure('Invalid SCULocation Model: Unknown type');
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCULocation Model: ".concat(e.message));
        }
    };
    SCUUtils.getModelName = function (model) {
        switch (model) {
            case SCUModelEnum.p1:
                return 'Raspberry Pi Pro';
            case SCUModelEnum.s1:
                return 'Raspberry Pi Slim';
            case SCUModelEnum.s2:
                return 'x86 Slim';
            case SCUModelEnum.p2:
                return 'x86 Pro SuperLogics';
            case SCUModelEnum.p3:
                return 'x86 Pro Logic Supply';
            case SCUModelEnum.p3g:
                return 'x86 Pro Logic Supply +4G';
            case SCUModelEnum.other:
                return 'Other';
        }
    };
    SCUUtils.getModelId = function (model) {
        return SCUModelEnum[model].toUpperCase();
    };
    SCUUtils.serialToIpAddress = function (serial) {
        var match = serial.match(SCUUtils.serialRegex);
        if (match == null) {
            return null;
        }
        return '10.31.' + (0, functions_1.range)(2, 4).map(function (i) { return parseInt(match[i], 16); }).join('.');
    };
    SCUUtils.serialToEmail = function (serial) {
        var match = serial.match(SCUUtils.serialRegex);
        if (match == null) {
            return null;
        }
        return "".concat(serial.toLowerCase(), "@scu.bryx.com");
    };
    SCUUtils.getScuApiJsonString = function (email, password, nonSupportApiRoot) {
        return JSON.stringify({
            user: email,
            password: password,
            url: nonSupportApiRoot,
        });
    };
    SCUUtils.serialRegex = /([0-9A-F]{2})-([0-9A-F]{2})-([0-9A-F]{2})/;
    SCUUtils.macRegex = /[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}/;
    SCUUtils.migrationSerial = '00-00-00';
    return SCUUtils;
}());
exports.SCUUtils = SCUUtils;
//# sourceMappingURL=scu.js.map